import { render, staticRenderFns } from "./page.vue?vue&type=template&id=378d4156&scoped=true&"
import script from "./page.vue?vue&type=script&lang=js&"
export * from "./page.vue?vue&type=script&lang=js&"
import style0 from "./page.vue?vue&type=style&index=0&id=378d4156&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378d4156",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('378d4156')) {
      api.createRecord('378d4156', component.options)
    } else {
      api.reload('378d4156', component.options)
    }
    module.hot.accept("./page.vue?vue&type=template&id=378d4156&scoped=true&", function () {
      api.rerender('378d4156', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/blindDetail/page.vue"
export default component.exports